import React, { Component } from 'react';
import FormHandler from 'AdminApp/common/script/services/crud/FormHandler';
import ResetPasswordModel from 'AdminApp/common/script/models/security/ResetPasswordModel';
import InputField from 'AdminApp/common/script/components/ui/InputField';
import { connect } from 'react-redux';
import { loginTriggerAction } from 'AdminApp/modules/auth/AuthActions';
import { Link } from 'react-router-dom';
import FormSubmitWrapper from 'AdminApp/common/script/components/crud/FormSubmitWrapper';
import LoadingOverlay from '../../common/script/components/LoadingOverlay';


const mapDispatchToProps = dispatch => {
  return {
    userLoggedIn: (token, account) => {
      return dispatch(loginTriggerAction(token, account))
    }
  }
}

@connect(null, mapDispatchToProps)
export default class ForgotPassword extends Component {

  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);

    // Initial state
    this.formHandler = new FormHandler(this, new ResetPasswordModel({
      password: '',
      repeatedPassword: '',
      hash: props.match.params.hash
    }), {
      hash: props.match.params.hash,
      valid: false
    });
  }

  componentDidMount() {
    this._checkHash(this.state.hash)
  }

  onSubmitSuccess(data) {
    if (data.success && data.data.token) {
      this.props.userLoggedIn(data.data.token, data.data.account);
    }
  }

  async _checkHash(hash) {
    if(!hash) {
      this.props.history.replace('/login');
    }

    let result = await ResetPasswordModel.checkHash(hash);

    if(!result) {
      this.props.history.replace('/login');
    }

    this.setState({
      valid: true
    })
  }

  _getModalMessage(data) {
    if (!data.success) {
      return data.responseJSON.message
    } else {
      return data.message
    }
  }

  _getInnerElement() {
    if(!this.state.valid) {
      return <div>
        <LoadingOverlay/>
      </div>
    }

    return this._getFormElement();
  }

  _getFormElement() {
    let formHandler = this.formHandler;
    return (
      <div>
        <h2>Reset Password</h2>
        <FormSubmitWrapper showBtn={false} formHandler={formHandler} to='/login' buttonText='Reset password' getModalMessage={data => this._getModalMessage(data)}>
          <InputField
            materialProps={{
              fullWidth: true
            }}
            classes={'loginInput'}
            label="New password*"
            type="password"
            name="password"
            InputLabelProps={{
              shrink: true,
            }}
            value={this.state.record.password}
            handler={formHandler} />

          <InputField
            materialProps={{
              fullWidth: true
            }}
            classes={'loginInput'}
            label="Repeat password*"
            type="password"
            name="repeatedPassword"
            InputLabelProps={{
              shrink: true,
            }}
            value={this.state.record.repeatedPassword}
            handler={formHandler} />
          <Link to='/login' className='back-button'>Back to login</Link>
        </FormSubmitWrapper>
      </div>
    )
  }

  /**
   * Render template
   *
   * @returns {XML}
   */
  render() {
    return (
      <div>
        {this._getInnerElement()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/ResetPassword.js